import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import IsolationGroupsResource from "@ane/exp-data/lib/resources/expapiv2/IsolationGroups.resource";
import { combineEpics } from "redux-observable";
import { resetCreateResult } from "./actions.js";
import { prefix } from "./constants.js";
import { appendIsolationGroup } from "../../common/epics/actions.js";
const createIsolationGroupEpicReducerArgs = {
  actionPrefix: `${prefix}/CREATE`,
  reduxKeyNested: () => ["createResult"],
  loadResource: (inputPayload) => IsolationGroupsResource.createIsolationGroup(inputPayload.workspaceId, inputPayload.isolationGroup),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    appendIsolationGroup(outputPayload),
    resetCreateResult()
  ]
};
const createIsolationGroupEpicReducer = loadResourcesUtils(createIsolationGroupEpicReducerArgs);
const rootEpic = combineEpics(createIsolationGroupEpicReducer.epic);
export {
  createIsolationGroupEpicReducer,
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
